// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3sqXg","container":"styles_container__3Ytu8","title":"styles_title__1OTd7","wrapper":"styles_wrapper__2ftsr","answer":"styles_answer__1a88R"};